export default function State() {

  Object.defineProperty(this, 'status', {
    get() {
      return this.type.charAt(0).toUpperCase() + this.type.slice(1);
    }
  });
}



// WEBPACK FOOTER //
// ./src/store/selectors/BidState/State.js